<template>
  <ValidationObserver
    class="updateable"
    tag="tr"
  >
   <td class="gray">
                  <div class="tabulka__body__userProfileIcon"></div>
                  {{ player.id }}
                </td>

                <td>
                  {{ player.username }}
                </td>
                <td>
                  {{ player.role }}
                </td>
                <td v-if="player.active == true">
                  <span class="tabulka__body__activeUser" >Aktivní</span>
                </td>
                <td v-else>
                  <span class="tabulka__body__notActiveUser">Neaktivní</span>
                </td>
                <td class="right" v-if="amIAdmin">
                  <button
                    v-if="player.active && player.role != 'ADMIN'"
                    @click="deactivate(player.id)"
                    class="tabulka__body__deactivateButton"
                  >
                    Deactivate
                  </button>
                  <button
                    v-else-if="player.role != 'ADMIN'"
                    @click="activate(player.id)"
                    class="tabulka__body__activateButton"
                  >
                    Activate
                  </button>
                   <button
                    v-if="!editMode && player.role != 'ADMIN'"
                    @click="edit()"
                    class="editButton"
                  >
                    Edit
                  </button>
                   <select v-if="editMode" style="width: 30%;" v-model="form.role">
                    <option value="ADMIN">Admin</option>
                    <option value="GAME_OWNER">Game owner</option>
                    <option value="PLAYER">Player</option>
                  </select>
                  <button
                    v-if="editMode && player.role != 'ADMIN'"
                    @click="save()"
                    class="confirmButton"
                  >
                    Confirm
                  </button>
                 <span v-if="player.role == 'ADMIN'">Role admin nelze změnit</span>
                </td>
  </ValidationObserver>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";



export default {
  name: "MediatypeRow",
  props: {
    player: Object,

  },

  data: function () {
    return {
      editMode: false,
      form: this.createForm()
    };
  },
    methods: {
    notMe(id) {
      if (id == this.myId) {
        return false;
      }
      return true;
    },
    createForm() {
      return { ...this.player };
    },
    deactivate(user) {
      this.$store.dispatch("deactivateUser", user);
    },
    activate(user) {
      this.$store.dispatch("activateUser", user);
    },
    edit(){
        this.editMode = true
    },
    save(){
        this.editMode = false
        console.log(this.form)
        this.$store.dispatch("changeRole", {id: this.form.id, role: this.form.role})
    }

  },
    computed: {
    ...mapGetters({
      amIAdmin: "amIAdmin",
    }),
    }



};
</script>
